module.exports = __webpack_public_path__ + "03_short_black.815c0085.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/03_short_black.png
// module id = ov60
// module chunks = 0